export const parse = rawData => ({
    serpchecker: rawData.serpchecker,
    serpcheckerBeta: rawData.serpchecker_beta,
});
